module.exports = "/_next/static/images/video_id_7114739889132047662-d6a64cbf44e618396738034eec05e731.jpg";